interface ClickOutsideTarget {
  el: HTMLElement
  onClickOutside: (e: MouseEvent) => any
}

const registeredList: ClickOutsideTarget[] = []

function documentClickHandler(evt: MouseEvent) {
  const targetEl = evt.target as Element
  // 忽略注释节点或穿透元素
  if (
    targetEl === null ||
    targetEl.nodeType === 8 ||
    targetEl.classList.contains('no-pointer-events')
  ) {
    return
  }
  for (const targetObj of registeredList) {
    if (targetObj.el.contains(targetEl) === false || document.body === targetEl) {
      targetObj.onClickOutside(evt)
    }
  }
}

// 检测是否注册
function checkRegistered(target: ClickOutsideTarget) {
  return registeredList.some((item) => item.el === target.el)
}

/**
 * 注册click outside元素
 * @param target ClickOutsideTarget
 */
export function addClickOutside(target: ClickOutsideTarget) {
  if (checkRegistered(target) === false) {
    registeredList.push(target)
  }

  if (registeredList.length === 1) {
    document.addEventListener('click', documentClickHandler, false)
  }
}

/**
 * 移除click outside元素
 * @param target ClickOutsideTarget
 */
export function removeClickOutside(target: ClickOutsideTarget) {
  const removeIndex = registeredList.findIndex((item) => item.el === target.el)
  if (removeIndex > -1) {
    registeredList.splice(removeIndex, 1)
  }
  if (registeredList.length === 0) {
    document.removeEventListener('click', documentClickHandler, false)
  }
}

export default {
  addClickOutside,
  removeClickOutside,
}
